import React from 'react';
import { LegalDocumentPage } from './LegalDocumentPage';

const sections = [
  {
    title: '지원 범위',
    body: [
      '고객지원은 로그인 문제, 프로필 등록 오류, 커뮤니티 신고, 예비군 지도 정보, 주문 및 결제 문의 등 서비스 이용 중 발생하는 운영 이슈를 다룹니다.',
      '법률 해석, 군 행정 절차의 공식 답변, 외부 기관 원천 데이터의 정정 요청은 고객지원 범위를 벗어날 수 있습니다.',
    ],
  },
  {
    title: '문의 전 준비 사항',
    body: [
      '오류나 문의 내용을 보다 빠르게 처리하기 위해서는 발생 시각, 사용 환경, 재현 방법, 화면 주소를 함께 정리해 주는 것이 좋습니다.',
      '결제 문의의 경우 주문 식별 정보, 결제 시각, 결제 수단, 오류 메시지를 함께 전달하면 처리 속도가 빨라집니다.',
    ],
    bullets: [
      '오류 발생 시각과 화면 주소',
      '브라우저 또는 기기 정보',
      '재현 순서와 오류 문구',
      '주문·결제 관련 문의 시 주문 또는 결제 식별 정보',
    ],
  },
  {
    title: '처리 우선순위',
    body: [
      '운영팀은 로그인 불가, 결제 오류, 개인정보 요청, 커뮤니티 신고, 일반 문의 순으로 우선순위를 두고 검토합니다.',
      '보안 또는 권리침해와 관련된 신고는 일반 문의보다 우선 처리될 수 있으며, 필요한 경우 추가 자료 제출을 요청할 수 있습니다.',
    ],
  },
  {
    title: '응답 기준',
    body: [
      '일반 문의는 영업일 기준으로 접수 순서에 따라 순차적으로 검토되며, 결제 오류와 로그인 장애 등 서비스 이용이 막히는 이슈는 우선 대응합니다.',
      '운영량, 외부 결제사 확인, 데이터 원천 제공기관 응답 여부에 따라 실제 처리 시간은 달라질 수 있습니다.',
    ],
    bullets: [
      '일반 문의: 접수 후 순차 검토',
      '로그인 및 결제 이슈: 우선 대응',
      '신고 처리: 사실관계 확인 후 정책에 따라 조치',
    ],
  },
  {
    title: '커뮤니티 신고 및 계정 이슈',
    body: [
      '욕설, 사칭, 도배, 허위정보, 개인정보 노출, 불법 콘텐츠에 대한 신고는 운영 정책에 따라 검토되며, 필요한 경우 게시물 제한 또는 계정 제한 조치가 이루어질 수 있습니다.',
      '반복적 허위 신고나 악의적 신고는 별도 검토 후 제한 대상이 될 수 있습니다.',
    ],
  },
  {
    title: '안내 사항',
    body: [
      '고객지원 페이지는 서비스 이용 기준과 처리 절차를 안내하기 위한 문서이며, 실제 문의는 서비스 내 제공되는 운영 채널과 공지 기준에 따라 접수됩니다.',
      '정책 변경이나 운영 방식 변경이 있는 경우, 본 페이지의 내용도 함께 업데이트될 수 있습니다.',
    ],
  },
] as const;

export const SupportPage: React.FC = () => {
  return (
    <LegalDocumentPage
      eyebrow="Support Center"
      title="고객지원 안내"
      description="짬밥요리사 이용 중 발생하는 오류, 결제 문제, 신고 및 계정 이슈를 어떤 기준으로 접수하고 처리하는지 안내합니다."
      sections={[...sections]}
    />
  );
};
